import { FC, useEffect, memo, useCallback, useRef, MutableRefObject, useState } from "react";
import { AppThunk } from "../../store";
import JSONString from "../components/JSONString";
import { Typography, debounce } from "@mui/material";
import AdminPage from "../AdminPage";
import { useParams } from "react-router-dom";
import { apiClient } from "../../utils/apiClient";

export type Props = {};

const Doc: FC<Props> = (props: Props): JSX.Element => {
  const {id: docId} = useParams();
  const [doc, setDoc] = useState();
  const [chunks, setChunks] = useState<any[]>([]);
  const [context, setContext] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
      const data = await apiClient.post<any>(`/document/doc/${docId}`);
        setDoc(data);
        setContext(data.context);
      } catch (error) {
        console.error('Error fetching requests:', error);
      }
    };
    fetchData();
  }, [docId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await apiClient.post<any>(`/document/doc/${docId}/chunks`);
        setChunks(data);
      } catch (error) {
        console.error('Error fetching requests:', error);
      }
    };
    fetchData();
  }, [docId]);

  const updateDocContextDebounced = debounce(async (newContext: string) => {
    await apiClient.post(`/document/doc/${docId}/update`, { context: newContext })
  }, 1000);

  const updateDocContext = useCallback(
    (newContext: string) => updateDocContextDebounced(newContext), [updateDocContextDebounced]
  );

  const handleContextChange = (e: any) => {
    const newContext = e.target.value;
    setContext(newContext);
    updateDocContext(newContext);
  };

  return (
    <AdminPage>
      <div>
        <Typography gutterBottom sx={{ mt: 2 }}>
          Context
        </Typography>
        <textarea
          value={context}
          onChange={handleContextChange}
          style={{ width: '100%', minHeight: '100px' }}
        />
      </div>
      <div>
        <JSONString data={doc} />
      </div>

      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Chunks
      </Typography>

      {chunks.map(c => {
        return <div key={c._id}>
          <JSONString data={c} />
        </div>
      })}
    </AdminPage>
  );
};

// server-side data here
export const loadData = (): AppThunk[] => [];

export default memo(Doc);
